module.exports = __webpack_public_path__ + "public/images/netw-how-to-use.4f8712f33dbe771aaca3e4f8367d4c34.png";